import { render } from "./modal_patient_edit.vue?vue&type=template&id=4ff7ae0f"
import script from "./modal_patient_edit.vue?vue&type=script&lang=js"
export * from "./modal_patient_edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__